// src/pages/RegistrationSuccess.tsx
// Legacy
import React from "react";
import { Link } from "react-router-dom";
import { FaHome } from "react-icons/fa";

export default function RegistrationSuccess() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header (matches the mentor register style) */}
      <header className="bg-gradient-to-r from-[#009fe3] to-[#0088cc] shadow-lg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4">
          <div className="mb-3">
            <h1 className="text-xl sm:text-2xl font-bold text-white">
              Registration Completed
            </h1>
            <div className="text-xs sm:text-sm text-white/90 mt-0.5 font-medium">
              Guideline2Germany
            </div>
          </div>

          <div
            className="flex items-center gap-2 text-white/90 text-sm"
            style={{ fontSize: "16px" }}
          >
            <Link
              to="/"
              className="inline-flex items-center hover:text-white transition-colors"
            >
              <FaHome className="mr-1.5" size={14} />
              <span>Home</span>
            </Link>
            <span className="text-white/60">/</span>
            <span className="text-white font-medium">Legacy Registration</span>
          </div>
        </div>
      </header>

      {/* Body */}
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-10">
        <div className="bg-white rounded-xl shadow-lg p-8">
          <div className="text-6xl mb-4">✅</div>
          <h2 className="text-3xl font-bold mb-2 text-gray-900">
            Registration received
          </h2>
          <p className="text-gray-700 mb-6">
            An admin will review your details and activate your access soon.
            You’ll be able to log in and use all student features once the
            activation is complete.
          </p>

          <div className="flex flex-col sm:flex-row gap-3">
            <Link
              to="/"
              className="flex-1 bg-[#009fe3] hover:bg-[#007cb5] text-white px-6 py-3 rounded-lg font-semibold text-center transition"
            >
              Back to Home
            </Link>
            <Link
              to="/login"
              className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-800 px-6 py-3 rounded-lg font-semibold text-center transition"
            >
              Go to Login
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}
